import {IMessage, IContact} from '../schemas/entity_set';
import {IMessageService} from './message_service';

class MessengerCtrl {
    sending: boolean;
    newMessage: IMessage;

    static $inject = ["$uibModalInstance", "MessageService", "Member"];
    constructor(private $uibModalInstance: angular.ui.bootstrap.IModalServiceInstance,
        private messageService: IMessageService,
        private message: IMessage) {
        this.newMessage = angular.copy(message)
    }

    sendMessage() {
        this.sending = true
        this.messageService.sendMessage(this.newMessage).then((res) => {
            this.sending = false
            if (res.success) { this.close() }
        })
    }

    close() { this.$uibModalInstance.dismiss("cancel") }

}

export {MessengerCtrl}


// WEBPACK FOOTER //
// ./app/messenger/messenger_ctrl.ts